import React from 'react';
import { formatSignedUsd, formatUsd } from '../../utils/format';
interface StoredReferenceProps {
  value: number;
  signed?: boolean;
  /** Show only the amount (for table cells); the column header carries the label. */
  compact?: boolean;
  className?: string;
}

/** Small grey Stored (unadjusted) reference figure. The Adjusted amount is what pays. */
export function StoredReference({
  value,
  signed = false,
  compact = false,
  className = ''
}: StoredReferenceProps) {
  const amount = signed ? formatSignedUsd(value) : formatUsd(value);
  return <span className={`text-[11px] font-normal tabular-nums text-sf-weak ${className}`} data-id="element-904" data-mp="2oy4ozxdz9k3j">
      {compact ? amount : `Stored (unadjusted) – reference ${amount}`}
    </span>;
}